module.exports = __webpack_public_path__ + "img/icon_map_199_off_011.8f1d85cc.png";